export const getControlsByCompanyNameQuery = (companyName: string) => { 
    return `
    {
        controlsByCompanyName(companyName:"${companyName}"){
          id
          companyControlId
          mainSystem {
            entity {
              name
            }
            system {
              name
            }
          }
          objective {
            name
          }
          systemsArr
          consolidationConfig
          systemConsolidations
          hrSystem {
            system {
              name
            }
            entity {
              name
            }
          }
          ticketSystem {
            system {
              name
            }
            entity {
              name
            }
          }
            }
    }
    `
}